import { __assign } from "tslib";
import get from 'lodash/get';
import { reduxKey } from './constants';
import { initialState } from './reducer';
import { flagEnabled } from '../../redux/flags/selectors';
import { getCurrentStreamId } from '../../Duperbrowse/redux/selectors';
import { FEEDBACK_PAGE_DUPERBROWSE_STREAMID } from '../../Duperbrowse/redux/constants';
export function getSiteHeaderState(state) {
    var headerState = get(state, reduxKey, initialState);
    if (flagEnabled(state, 'force_notifs_open')) {
        headerState = __assign(__assign({}, headerState), { isNotificationsDropdownOpen: true });
    }
    return headerState;
}
export function getIsBurgerMenuOpen(state) {
    return getSiteHeaderState(state).isBurgerMenuOpen;
}
export function getIsFeedbackPageOpen(state) {
    return getCurrentStreamId(state) === FEEDBACK_PAGE_DUPERBROWSE_STREAMID;
}
//# sourceMappingURL=selectors.js.map